<div class="wrapper">
    <div class="wrapper__header">
        <mat-icon>no_encryption_gmailerrorred</mat-icon>
    </div>
    <div class="content__header">
        <span> Are you sure you want to logout? </span>
    </div>
    <div class="footer">
        <button class="button-blue" mat-flat-button (click)="logout()">
            <span class="button__text-primary">Logout</span>
        </button>
        <button class="button--white" mat-flat-button (click)="cancel()">
            <span class="button__text-secondary">Cancel</span>
        </button>
    </div>
</div>
